<template>
    <div>
        <div class="t_h2_txt1">
            <i class="el-icon-back return_icon" @click="$router.go(-1)"></i>{{data_all.card_name}}
        </div>

        <div class="th_info">
            <div class="th_info_top">{{$t('bank_card.KYC_info')}}</div>
            <div class="th_info_main">
                <div class="th_tit1">{{$t('bank_card.Personal_Details')}}</div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text518')}}</div>
                    <div class="th_tit4">{{data_all.title}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text519')}}</div>
                    <div class="th_tit4">{{data_all.first_name}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text520')}}</div>
                    <div class="th_tit4">{{data_all.last_name}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text185')}}</div>
                    <div class="th_tit4">{{data_all.email}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('bank_card.Personal_Details')}}</div>
                    <div class="th_tit4">{{data_all.mobile_number}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text522')}}</div>
                    <div class="th_tit4">{{data_all.date_of_birth}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('bank_card.Gender')}}</div>
                    <div class="th_tit4">{{data_all.gender}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text290')}}</div>
                    <div class="th_tit4">{{data_all.address}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text526')}}</div>
                    <div class="th_tit4">{{data_all.city}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text525')}}</div>
                    <div class="th_tit4">{{data_all.state}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text524')}}</div>
                    <div class="th_tit4">{{data_all.country}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text527')}}</div>
                    <div class="th_tit4">{{data_all.postal_code}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('bank_card.Username_Beth')}}</div>
                    <div class="th_tit4">{{data_all.username}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('bank_card.Name_appear')}}</div>
                    <div class="th_tit4">{{data_all.card_name}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text620')}}</div>
                    <div class="th_tit4">{{data_all.des}}</div>
                </div>
                
                <div class="th_tit1 title_bottom">{{$t('bank_card.Proof_Identity')}}</div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text697')}}</div>
                    <div class="th_tit4">{{data_all.id_type}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('bank_card.Passport_National')}}</div>
                    <div class="th_tit4">{{data_all.passport_number}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text530')}}</div>
                    <div class="th_tit4">{{data_all.issued_date}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text531')}}</div>
                    <div class="th_tit4">{{data_all.expiration_date}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text617')}}</div>
                    <div class="th_tit4">{{data_all.issued_by}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('bank_card.Select_language')}}</div>
                    <div class="th_tit4">{{data_all.language}}</div>
                </div>

                <div class="th_tit1 title_bottom">{{$t('bank_card.Proof_Identity')}}</div>
                    <div class="th_tit2">
                        <div class="th_tit3">{{$t('bank_card.Address_Proof')}}</div>
                        <!-- <div class="th_tit4">{{data_all.address_proof_front}}</div> -->
                        <div class="th_tit4">
                            <el-image 
                                v-if="data_all.address_proof_front"
                                style="width: 100px; height: 100px"
                                :src="data_all.address_proof_front" 
                                :preview-src-list="[data_all.address_proof_front]">
                            </el-image>
                        </div>
                    </div>
                    <div class="th_tit2">
                        <div class="th_tit3">{{$t('bank_card.Address_Proof_Back')}}</div>
                        <!-- <div class="th_tit4">{{data_all.address_proof_back}}</div> -->
                        <div class="th_tit4">
                            <el-image 
                                v-if="data_all.address_proof_back"
                                style="width: 100px; height: 100px"
                                :src="data_all.address_proof_back" 
                                :preview-src-list="[data_all.address_proof_back]">
                            </el-image>
                        </div>
                    </div>
                    <div class="th_tit2">
                        <div class="th_tit3">{{$t('bank_card.Address_Type')}}</div>
                        <div class="th_tit4">{{data_all.address_type}}</div>
                    </div>
                    <div class="th_tit2">
                        <div class="th_tit3">{{$t('bank_card.Address_Language')}}</div>
                        <div class="th_tit4">{{data_all.address_language}}</div>
                    </div>
                    <div class="th_tit2">
                        <div class="th_tit3">{{$t('bank_card.Address_Issued_By')}}</div>
                        <div class="th_tit4">{{data_all.address_issued_by}}</div>
                    </div>
                    <div class="th_tit2">
                        <div class="th_tit3">{{$t('bank_card.Address_Issued_Date')}}</div>
                        <div class="th_tit4">{{data_all.address_issued_date}}</div>
                    </div>
            </div>
        </div>
    </div>
</template>

<script>
import {getCardKyc} from '@/api/api';
export default {
    data() {
        return {
            data_all:'',
            // order_id:this.$route.query.order_id,
            top_name:this.$route.query.name,
        }
    },
    beforeDestroy(){
        sessionStorage.removeItem('top_title_name');
    },
    mounted() {
        sessionStorage.setItem('top_title_name',' ');
        this.get_list();
    },
    methods: {
        get_list(){
            getCardKyc({card_id:this.top_name}).then(res=>{
                if (res.data.code==200) {
                    this.data_all=res.data.data;
                    // console.log(res.data.data);
                }
            })
        },

    },
}
</script>

<style scoped>
.th_info{
    background: #314B69;
    border-radius: 16px;
}
.th_info_top{
    box-sizing: border-box;
    padding: 28px;
    border-bottom: 1.5px solid #041E35;
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 26px;
}
.th_info_main{
    box-sizing: border-box;
    padding: 28px;
}
.th_tit1{
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    line-height: 18px;
    margin-bottom: 12px;
}
.th_tit2{
    margin-bottom: 12px;
    display: flex;
}
.th_info_main .th_tit2:last-child{
    margin-bottom: 0;
}
.th_tit3{
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 18px;
    color: rgba(255, 255, 255, 0.6);
    width: 160px;
    margin-right: 28px;
    display: inline-block;
}
.th_tit4{
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
    display: inline-block;
}
.title_bottom{
    margin-top: 30px;
}
.return_icon{
  cursor: pointer;
  margin-right: 10px;
}
.t_h2_txt1{
  font-style: normal;
  font-size: 20px;
  line-height: 26px;
  margin-bottom: 15px;
}
</style>